import { render, staticRenderFns } from "./SelectColumns.vue?vue&type=template&id=99d36f70&scoped=true&"
import script from "./SelectColumns.vue?vue&type=script&lang=js&"
export * from "./SelectColumns.vue?vue&type=script&lang=js&"
import style0 from "./SelectColumns.vue?vue&type=style&index=0&id=99d36f70&scoped=true&lang=scss&"
import style1 from "./SelectColumns.vue?vue&type=style&index=1&id=99d36f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d36f70",
  null
  
)

export default component.exports